export default {
    title: "Dostava",
    subtitle: "Odaberite gradove u kojima vršite dostavu Vaših proizvoda.",
    defaultPrice: "Cijena dostave",
    modal: {
        title: "Odredi cijenu dostave",
        close: "Zatvori",
        confirm: "Potvrdi"
    },
    municipalities: {
        title: "Gradovi",
        placeholder: "Odaberite jedan ili više gradova",
        button: "Dodaj odabrano",
        buttonAll: "Dodaj sve gradove"
    },
    table: {
        municipality: "Grad",
        price: "Cijena dostave",
        minimalValue: "Minimalna cijena porudžbine",
        active: "Aktivna",
    },
    notDelivering: "Trenutno ne vršite dostavu ni u jednom gradu.",
};
